import Vue from 'vue'
import Vuex from 'vuex'
import scene from './scene'
import flow from './flow'
import intents from './intents'
import setting from './setting'
import rules from './rules'
import eventRules from './eventRules'
import knowledge from './knowledge'
import user from './user'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    scene,
    flow,
    intents,
    setting,
    rules,
    eventRules,
    knowledge,
    user,
  }
})